
/*
 *   File : add-bank-upi-verification.js
 *   Author URI : https://evoqins.com
 *   Description : Modal component for upi verification
 *   Integrations : null
 *   Version : v1.1
 */
import { useState, useEffect } from 'react';
import Icon from '../../Icon/icon';
import { toast } from 'react-toastify';

import { GradientButton, OutlineButton } from '../../CTA';
import { CustomLoader } from '../../Other';

import APIService from '../../../Service/api-service';

import style from '../../../Styles/Component/add-bank.module.scss';
import Colors from '../../../Styles/color.module.scss';

export default function AddBankUPIVerification(props) {

    let timer = 0;

    const [loader, setLoader] = useState(true);
    const [simulationType, setSimulationType] = useState(true);

    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );

    useEffect(() => {
        if (props.data !== null) {
            setLoader(false);
        }
    }, [props.data]);

    // Directly checking add bank status via upi if production
    useEffect(() => {
        if (process.env.REACT_APP_ENV === 'PROD') {
            _callCheckUPIStatusAPI();
        }
    }, []);

    // Clearing timer when unmounting the Qr code
    useEffect(() => {
        return () => {
            clearInterval(timer);
        };
    }, []);

    function _callCheckUPIStatusAPI() {
        timer = setInterval(() => {
            _checkUPIStatus();
        }, 3000);
    }

    const openUpi = (type) => {
        toast.dismiss();
        let upiUrl = props.data.upiLink
        // Detect if mobile device      

        const schemeMap = {
            phonepe: "phonepe://pay?",
            gpay: "gpay://upi/",
            paytm: "paytmmp://pay?pa=",
            bhim: "bhim://upi/"
        };

        let finalUrl = upiUrl;
        if (type === "paytm") {
            finalUrl = upiUrl.replace("upi://pay?pa=", schemeMap.paytm);
        } else if (type === "phonepe") {
            finalUrl = upiUrl.replace("upi://pay?", schemeMap.phonepe);
        } else {
            finalUrl = upiUrl.replace("upi://", schemeMap[type]);
        }

        let appOpened = false;
        const handleVisibilityChange = () => {
            if (document.hidden) {
                appOpened = true;
            }
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        // Set timeout to show error if app didn’t open
        const timeout = setTimeout(() => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            if (!appOpened) {
                toast.error(`${type.toUpperCase()} is not installed on this device.`);
            }
        }, 2000);

        console.log(finalUrl)
        window.location.href = finalUrl;

    };

    // API :: payment simulation
    function _paymentSimulation(status) {
        setLoader(true);
        setSimulationType(status);
        let url = 'profile/banks/simulate';
        let payload = JSON.stringify({
            id: props.data.id,
            status
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                _checkUPIStatus();
            } else {
                // props.handleSimulationStatus(false);
                toast.error(response.message, {
                    type: 'error'
                });
                setLoader(false);
            }
        })
    }

    // API :: check UPI status
    function _checkUPIStatus() {
        let url = 'profile/banks/check-status';
        let payload = JSON.stringify({
            id: props.data.id
        });
        APIService(true, url, payload)
            .then((response) => {
                if (response.status_code === 200 && response.data === 'success') {
                    props.handleUPIVerificationSuccess(true);
                    clearInterval(timer);
                    setLoader(false);
                }
                else if (response.status_code === 400) {
                    toast.error(response.message, { type: 'error' });
                    props.handleUPIVerificationSuccess(false);
                    clearInterval(timer);
                    setLoader(false);
                }
            })
            .catch((error) => {
                clearInterval(timer);
                setLoader(false);
            });
    };

    return (
        <div className={`container gx-0 ${style.e_scroll_container}`}>
            <div className="row">
                <div className="col-12 text-start">
                    {
                        props.kycFlow === false &&
                        <h4 className="color-black e-poppins-medium e-font-16 cursor-pointer mt-1"
                            onClick={() => props.navigation()}>
                            <Icon icon="back-arrow"
                                color={Colors.black}
                                size={24}
                                className={`me-3`} />
                            Link your bank account
                        </h4>
                    }
                </div>
                <div className="col-12 text-start mt-4">
                    <p className="color-outer-space e-poppins-regular e-font-14">
                        Scan the below qr code with any UPI app to complete the bank verification.
                    </p>
                </div>
                <div className="col-12 my-3">
                    <div className="d-flex justify-content-center">
                        <img src={require('../../../Assets/Images/profile/phonePay.svg').default}
                            alt="Phone pay"
                            className={`me-3 ${!isMobile ? "no-events opacity-7" : ""}`}
                            onClick={() => openUpi("phonepe")} />
                        <img src={require('../../../Assets/Images/profile/gPay.svg').default}
                            alt="Google pay"
                            className={`me-3 ${!isMobile ? "no-events opacity-7" : ""}`}
                            onClick={() => openUpi("gpay")} />
                        <img src={require('../../../Assets/Images/profile/paytm.svg').default}
                            alt="Pay TM"
                            className={`me-3 ${!isMobile ? "no-events opacity-7" : ""}`}
                            onClick={() => openUpi("paytm")} />
                        <img src={require('../../../Assets/Images/profile/bhim.svg').default}
                            alt="BHIM"
                            className={`${!isMobile ? "no-events opacity-7" : ""}`}
                            onClick={() => openUpi("bhim")} />
                    </div>
                </div>
                <div className="col-12">
                    <div className={`d-flex justify-content-center ${style.e_qr_wrapper}`}>
                        <img src={`data:image/png;base64,${props.data.upi_qrcode_encoded_string}`}
                        />
                    </div>
                </div>
                {
                    process.env.REACT_APP_ENV !== 'PROD' && (
                        <div className="col-12 text-center mt-5">
                            <OutlineButton label="Simulate failure"
                                className={`padding-14px-tb padding-14px-lr`}
                                loading={simulationType === false && loader === true ? true : false}
                                handleClick={() => _paymentSimulation(false)} />
                            <GradientButton label="Simulate success"
                                className={`padding-14px-tb padding-36px-lr ms-3`}
                                loading={simulationType === true && loader === true ? true : false}
                                handleClick={() => _paymentSimulation(true)} />
                        </div>
                    )
                }

            </div>
        </div>
    )
};